import PropTypes from 'prop-types';

export const TRAINING_SESSION_PROP_TYPES = PropTypes.shape({
  description: PropTypes.string,
  end: PropTypes.string,
  groupName: PropTypes.string,
  id: PropTypes.number,
  organiser: PropTypes.shape({
    id: PropTypes.number,
    avatar: PropTypes.string,
    name: PropTypes.string,
  }),
  start: PropTypes.string,
  teams: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ),
  venue: PropTypes.string,
});

export const TRAINING_AVAILABILITY_PROP_TYPES = PropTypes.shape({
  memberId: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  note: PropTypes.string,
  member: PropTypes.shape({
    id: PropTypes.number,
    avatar: PropTypes.string,
    name: PropTypes.string,
  }),
});
